export const SET_SECTIONS = "SET_SECTIONS"
export const SET_SECTIONS_TEAMPLATE = "SET_SECTIONS_TEAMPLATE"
export const SET_ITEMS = "SET_ITEMS"
export const SET_SEARCH = "SET_SEARCH"
export const SET_PART = "SET_PART"
export const SET_PASSPORT_SECTION = "SET_PASSPORT_SECTION"
export const SET_PASSPORT_PARENT = "SET_PASSPORT_PARENT"
export const SET_VALUE = "SET_VALUE"
export const SET_NEW_VALUE = "SET_NEW_VALUE"
